<template>
  <div class="perfil-container">
    <header class="header">
      <h1 class="titulo">Meu Perfil</h1>
      <p class="subtitulo">Confira seus dados e altere a senha.</p>
    </header>

    <div v-if="loadingPerfil" class="loading-state">
      <div class="spinner"></div>
      <p>Carregando perfil...</p>
    </div>

    <div v-else class="grid">
      <section class="card">
        <h3 class="card-title">Dados pessoais</h3>
        <ul class="dados">
          <li><strong>Nome:</strong> {{ perfil?.funcionario_nome || perfil?.nome }}</li>
          <li><strong>Email:</strong> {{ perfil?.email || '-' }}</li>
          <li><strong>CPF:</strong> {{ perfil?.cpf || '-' }}</li>
          <li><strong>Cargo:</strong> {{ perfil?.cargo || '-' }}</li>
          <li><strong>Vínculo:</strong> {{ perfil?.vinculo || '-' }}</li>
          <li><strong>Data de admissão:</strong> {{ formatDate(perfil?.data_admissao) }}</li>
          <li><strong>Carga horária (mês):</strong> {{ perfil?.carga_horaria_mes || '-' }}</li>
          <li><strong>Carga horária (semana):</strong> {{ perfil?.carga_horaria_semanal || '-' }}</li>
        </ul>
      </section>

      <section class="card">
        <h3 class="card-title">Alterar senha</h3>
        <form @submit.prevent="alterarSenha">
          <div class="form-row">
            <label>Senha atual</label>
            <input type="password" v-model="formSenha.atual" required />
          </div>
          <div class="form-row">
            <label>Nova senha</label>
            <input type="password" v-model="formSenha.nova" required />
          </div>
          <div class="form-row">
            <label>Confirmar nova senha</label>
            <input type="password" v-model="formSenha.confirmar" required />
          </div>

          <div class="form-actions">
            <button class="btn-principal" type="submit" :disabled="loadingSenha">
              {{ loadingSenha ? 'Salvando...' : 'Salvar nova senha' }}
            </button>
          </div>
        </form>

        <p v-if="mensagem" :class="['mensagem', sucesso ? 'sucesso' : 'erro']">
          {{ mensagem }}
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services/authService';

export default {
  name: 'Perfil',
  data() {
    return {
      perfil: null,
      loadingPerfil: false,
      loadingSenha: false,
      mensagem: '',
      sucesso: false,
      formSenha: {
        atual: '',
        nova: '',
        confirmar: ''
      }
    };
  },
  methods: {
    formatDate(ts) {
      if (!ts) return '-';
      return new Date(ts).toLocaleDateString('pt-BR');
    },
    async carregarPerfil() {
      this.loadingPerfil = true;
      try {
        const r = await authService.getProfile();
        this.perfil = r.data;
      } catch (err) {
        console.error(err);
        this.mensagem = err.response?.data?.detail || 'Erro ao carregar perfil';
        this.sucesso = false;
      } finally {
        this.loadingPerfil = false;
      }
    },
    async alterarSenha() {
      if (this.formSenha.nova !== this.formSenha.confirmar) {
        this.mensagem = 'A confirmação da nova senha não confere.';
        this.sucesso = false;
        return;
      }

      this.loadingSenha = true;
      this.mensagem = '';
      try {
        await authService.changePassword({
          current_password: this.formSenha.atual,
          new_password: this.formSenha.nova
        });
        this.sucesso = true;
        this.mensagem = 'Senha alterada com sucesso!';
        this.formSenha.atual = '';
        this.formSenha.nova = '';
        this.formSenha.confirmar = '';
      } catch (err) {
        console.error(err);
        this.sucesso = false;
        this.mensagem = err.response?.data?.detail || 'Erro ao alterar senha';
      } finally {
        this.loadingSenha = false;
      }
    }
  },
  mounted() {
    this.carregarPerfil();
  }
};
</script>

<style scoped>
.perfil-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background: #f8fafc;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
}
.header { text-align: center; margin-bottom: 1rem; }
.titulo { font-size: 1.6rem; font-weight: 700; color: #1e293b; }
.subtitulo { color: #475569; }

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}
.card {
  background: white;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.card-title {
  font-weight: 700;
  margin-bottom: .6rem;
  color: #1e293b;
}
.dados {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dados li { margin: .35rem 0; color: #334155; }

.form-row {
  display: flex;
  flex-direction: column;
  margin-bottom: .8rem;
}
.form-row label { font-weight: 600; color: #475569; margin-bottom: .3rem; }
.form-row input {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.6rem 0.75rem;
  font-size: 1rem;
}
.form-actions {
  margin-top: .8rem;
  text-align: right;
}
.btn-principal {
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.65rem 1rem;
  font-weight: 700;
  cursor: pointer;
}
.btn-principal:disabled {
  opacity: .7;
  cursor: not-allowed;
}

.mensagem {
  margin-top: .6rem;
  padding: 0.75rem;
  border-radius: 8px;
  font-weight: 600;
}
.mensagem.sucesso { background: #dcfce7; color: #166534; border: 1px solid #bbf7d0; }
.mensagem.erro { background: #fee2e2; color: #b91c1c; border: 1px solid #fecaca; }

.loading-state {
  text-align: center;
  color: #475569;
}
.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  margin: 0 auto 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
